import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar, IonPopover } from '@ionic/react';

//import { Bluefin_Hotel_context } from '../../../storeState/bluefin_hotel_context';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';
//import { GetGuestSearchMatch } from './GetGuestSearchMatch';
//import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { PayModal_Hotel_Restaurant } from './Modal_Pay_Hotel_Restaurant';
//import {Registration_GeoLocation } from './Registration_GeoLocation'

import { Preferences } from '@capacitor/preferences'

function addStorage_cart(event) {

    //alert(event);

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}

export function Modal_Checkout_Hotel_Restaurant (props) {

    //let authenticatedMerchent_context = useContext(Auth_MerchantID_context);
    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [companyID, setCompanyID ] = useState(props.data.companyId);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    const [cartList, setCartList] = useState(authenticatedMerchent_context.cartList);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('mm');
    let [checkInCustomerStatus, setCheckInCustomerStatus ] = useState('member');
    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(null);

    let [ccInfoDisplay, setCCInfoDisplay ] = useState('none');
    let [mmInfoDisplay, setMMInfoDisplay ] = useState('none');
    let [checkingInfoDisplay, setCheckingInfoDisplay ] = useState('none');
    let [cashInfoDisplay, setCashInfoDisplay ] = useState('inline-block');


    let [cartSubtotal, setCartSubTotal] = useState(null);
    let [cartCheckoutTotal, setCartCheckoutTotal] = useState(null);
    let [cartArrayList, setCartArrayList] = useState([]);

    let [cartLatitude, setCartLatitude] = useState(null);
    let [cartLongitude, setCartLongitude] = useState(null);

    let [ openPayModal, setOpenPayModal] = useState(false);

    let [viewIonPopover, setvViewIonPopover] = useState(false);

    let [mobileNumber, setMobileNumber] = useState('');
    let [errorMessage, setErrorMessage] = useState('');

    let [enterFirstName, setEnterFirstName] = useState('');
    let [enterLastName, setEnterLastName] = useState('');

    //let selectCheckInDateRef = useRef();
    //let selectCheckOutDateRef = useRef();


    let enterQavaNumberRef = useRef(null);

    let enterMemberPaymentAmountRef = useRef();
    let enterFirstNameRef = useRef();
    let enterLastNameRef = useRef();
    let enterMobileNumberRef = useRef();
    let enterEmailRef = useRef();

    let enterID_numberRef = useRef('00000');
    
    let enterCC_numberRef = useRef();
    let enterCC_expDateRef = useRef();
    let enterCC_cvvNumberRef = useRef();
    let enterCC_addressRef = useRef();
    let enterCC_cityRef= useRef();
    let enterCC_stateRef = useRef();
    let enterCC_zipRef = useRef();
    let enterCC_nonMember_amountRef = useRef();

    let enterMM_displayRef = useRef();
    let selectMobileMoneyProviderRef = useRef();
    let enterMM_phoneNumberRef = useRef();
    let enterMM_nonMember_amountRef = useRef();


    let enterChecking_displayRef = useRef();
    let enterChecking_bankNameRef = useRef();
    let enterChecking_accountNumberRef = useRef();
    let enterChecking_routingNumberRef = useRef();
    let enterChecking_nonMember_amountRef = useRef();

    let enterCash_displayRef = useRef();
    let enterCash_amountRef = useRef();


function handleMobileNumberChange(e) {

    const input = e.detail.value || '';
    if (!input.startsWith('0')) {
        setErrorMessage('Mobile number must start with 0.');
    } else {
        setErrorMessage('');
    }
    setMobileNumber(input);
    //enterMobileNumberRef.current = input;
};


function handleEnterAttachement() {  


    fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
    .then(res => res.blob())
    .then(data => {

        //alert(JSON.stringify(data));

        const blobUrl = URL.createObjectURL(data);

        let noImageFile = new File([data], blobUrl, {
            enctype: 'multipart/form-data',
            type: 'image/jpeg',
            name: 'xImageFile',
            accept: "image/*",
        });
        
        setCheckInAttachment_ID(noImageFile);

        //alert("No Attachment Option checked");

    })
}

    function handleSelectPaymentType(e) { 
        e[1].persist(); 
        //alert('In HandleSelectPaymentType');
        //alert(e);

        let event = [e[0], e[1].target.value];
        
        if(event[0] == 'non_member')
        {
            setCheckInCustomerStatus(event[0]);  

            
            if(event[1] == 'non_member')
            {
                setCheckInNonMemberPaymentType('none');   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'cc')
            {

                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('inline-block');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            } 
            else if(event[1] == 'mm')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('inline-block');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'checking')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('inline-block');   
                setCashInfoDisplay('none');   

            }
            else if(event[1] == 'cash')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('inline-block');   
            } 
        } 

      
    }

function confirmCheckout(event)
{
    setOpenPayModal(false);

    //alert(checkInRoomID);
    //alert(roomSalePrice);

    if(cartList.size != 0)
    {

        //e.preventDefault();

        
        let formData = new FormData();
        //formData.append('user', acctID);
        //formData.append('sessionID', sessionID);
        //formData.append('xImageFile', checkInAttachment_ID);

        let activeAcctID;

        if(acctID == null)
        {
            activeAcctID = event[3];
        }
        else if(acctID != null)
        {
            activeAcctID = acctID;
        }

        let headers = new Headers();

        const requestOptions = {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('content-type', 'application/json'), 
            body: JSON.stringify({
                Tracker: '74706_confirmCheckout_hotel_public',
                user: activeAcctID,
                fmc_schema: schema,
                xCompanyID_public: props.data.companyId,
                baseUrl: baseURL,
                sessionID: sessionID,
                xCartList:  JSON.stringify(cartList),
                xCartFirstName: enterFirstName.replace(/\s+/g, '_'),
                xCartLastName: enterLastName.replace(/\s+/g, '_'),
                xCartMobileNumber: mobileNumber,
                //xCartEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                xCartSubtotal: cartSubtotal,
                xCartCheckoutTotal: cartSubtotal,
                xCartLatitude: cartLatitude,
                xCartLongitude: cartLongitude,
                //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,    
                xCartNonMemberPaymentType: checkInNonMemberPaymentType,
                xUserStatus: checkInCustomerStatus,
                xOrderID: event[1],
                xOrderID_customer: event[2],
                xOrderID_payStatus: event[0],

            }),
        }

        //alert('Inside GetAvaialbleRoom AFTER upload');
        //alert(baseURL);

        let newBaseURL = 'https://ghanaverified.com';
        if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
        {
            newBaseURL = 'https://ghanaverifiedtest.com'
        }

        //fetch(baseURL+'ghanaverified_hotel/', requestOptions)
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
            
            alert("CHECKOUT COMPLETE.")

            //alert(res);
    
        })

        props.closeModal(false);

    }
    


    else
    {
        //e.preventDefault();

        alert('Please Add Items to Cart');

    }

}

function retrieveCurrentGeolocation(event) 
{
    //alert("in get current registration coordinates");
    // alert(event);
    // alert(event[0]);
    // alert(event[1]);

    setCartLatitude(event[0]);
    setCartLongitude(event[1]);
}

function confirmCheckoutHandler(e)
{
    e.preventDefault();

    setOpenPayModal(true);

    //confirmGuestBooking(e);
}


function closeModalHandler() {

    setOpenPayModal(false);

    props.closeModal(false);
}  

function handlePopover() {

    setOpenPayModal(false);

    props.closeModal(false);
}    



async function deleteCartItem(index){


    const updatedCartArrayList = cartList.filter((_, i) => i !== index);

    setCartList(updatedCartArrayList);

    await addStorage_cart(updatedCartArrayList);


    authenticatedMerchent_context.changeCartList(updatedCartArrayList);


    let cartSubtotal = 0;

    for (let rownum = 0; rownum < updatedCartArrayList.length; ++rownum)
    {

        let cartItems = updatedCartArrayList[rownum];

        cartSubtotal += cartItems.price * cartItems.quantity;

    }
    

    let cartCheckoutTotal = cartSubtotal + (cartSubtotal * .15);

    setCartSubTotal(cartSubtotal);
    setCartCheckoutTotal(cartCheckoutTotal);

  };


useEffect(() => {

    // alert("IN USE EFFECT");
    // //  alert(acctID);
    //   alert(cartList);
    //   alert(cartList.length);
     //alert(JSON.parse(cartList[0]));
     //alert(JSON.parse(cartList[0]).price);

    let cartSubtotal = 0;

    for (let rownum = 0; rownum < cartList.length; ++rownum)
    {
        //alert("IN SUBTOTAL");

        let cartItems = cartList[rownum];

        // alert(cartItems.price);
        // alert(cartItems.quantity);

        cartSubtotal += cartItems.price * cartItems.quantity;

        //alert(cartSubtotal);


    }
    

    let cartCheckoutTotal = cartSubtotal + (cartSubtotal * .15);

    setCartSubTotal(cartSubtotal);
    setCartCheckoutTotal(cartCheckoutTotal);


    //const wrappedArrayString = `[${cartList}]`;

    //const cartArray = JSON.parse(wrappedArrayString);

    //setCartArrayList(wrappedArrayString);

    // alert("TOTAL CALCULATED");
    // alert(cartSubtotal);
    // alert(cartCheckoutTotal);

    
}, [])

//alert('Inside RETAIL CHECKOUT');
//alert(acctID);

return (
    <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal isOpen={ props.openModal }>
            <form onSubmit={confirmCheckoutHandler}>
            <IonHeader  style={{ color: "black" }}>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>CHECKOUT</IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setvViewIonPopover(true)}>View Cart</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
         
        </IonHeader>
                
            <IonContent className='grid_content'>

            {viewIonPopover && (

                <div
                //onClick={() => setvViewIonPopover(false)} // Close on backdrop click
                style={{
                position: 'absolute',
                width: '75%',
                height: '90%',
                backgroundColor: 'white',
                transform: 'translate(10%, 0%)',
                padding: '16px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                zIndex: 1000,
                borderRadius: '8px',       /* Rounded corners */
                border: '2px rgb(0, 0, 0) solid',
                }}
                >

                <IonGrid className='popOver'>
                    <IonRow >
                            <IonCol size='3'>Name</IonCol>
                            <IonCol size='3'>Price</IonCol>
                            <IonCol size='3'>Quantiy</IonCol>
                            <IonCol size='3'>Action</IonCol>
                        </IonRow>

                    {cartList.map((detailData, index) =>   {
                    return (
                        <IonRow key={detailData.id || index}>
                            <IonCol size='3'>{detailData.name || "N/A"}</IonCol>
                            <IonCol size='3'>{detailData.price || "N/A"}</IonCol>
                            <IonCol size='3'>{detailData.quantity || "N/A"}</IonCol>
                            <IonCol size='3'><IonButton className='small_button' onClick={() => deleteCartItem(index)}>Remove</IonButton></IonCol>
                        </IonRow>
                            )
                        }
                    )}
                </IonGrid>
                <IonButton onClick={() => setvViewIonPopover(false)}>close</IonButton>
                </div>
                )}   

                <IonGrid >
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel htmlFor="paymenttype">Payment Type </IonLabel>                                    
                        </IonCol>
                        <IonCol className='ionCol_inputContent'  size='6'>
                            <select name="paymenttype" id='paymenttype' onChange={(e) => setCheckInNonMemberPaymentType(e.target.value) }>
                                {/*<option value='cc'>Credit Card</option>*/}
                                <option value='mm' selected='selected'>Mobile Money</option>
                                {/*<option value='checking'>Checking</option>*/}
                                <option value='CASH'>Cash</option>*
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>First Name: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput type='text' placeholder='Enter' value={enterFirstName }  autocomplete='off' onIonChange={(e) => setEnterFirstName(e.target.value)} required></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Last Name: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput type='text' placeholder='Enter' value={enterLastName }  autocomplete='off' onIonChange={(e) => setEnterLastName(e.target.value)} required></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        {/*<IonCol size='6'>
                            <IonLabel>Mobile Number: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput placeholder='Enter' ref={enterMobileNumberRef} required></IonInput>
                        </IonCol>*/}
                        <IonCol size="6">
                            <label htmlFor="searchSupplierName">Mobile Number:</label>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size="6">
                            <IonInput
                                id="searchSupplierName"
                                placeholder="Enter mobile number"
                                type="tel"
                                value={mobileNumber}
                                onIonChange={(e) => handleMobileNumberChange(e)}
                                required/>
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Payment Amount: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput placeholder='Enter' ref={enterMM_nonMember_amountRef} required></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow >
                        <IonCol size='6'>
                            <IonLabel>SubTotal: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            {cartSubtotal}
                        </IonCol>
                    </IonRow>
                    {/*<IonRow >
                        <IonCol size='6'>
                            <IonLabel>Total: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            {cartCheckoutTotal}
                        </IonCol>
                    </IonRow>*/}
                </IonGrid>

                {/*<Registration_GeoLocation gps_location={retrieveCurrentGeolocation} ></Registration_GeoLocation>*/}

            </IonContent>

            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonButton type='submit' className='grid_checkInFooter_left' > Confirm Purchase </IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() => closeModalHandler()} className='grid_checkInFooter_right'> Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            </form>

            </IonModal>
            ) : null}

            {openPayModal == true && <PayModal_Hotel_Restaurant openModal={ openPayModal } closeModal={(event) => confirmCheckout(event)} payCloseModal={(event) => setOpenPayModal(event)} data={{
                    companyId: props.data.companyId,
                    companyPhoneNumber: props.data.companyPhoneNumber,
                    cartList: cartList,
                    firstName: enterFirstName, 
                    lastName: enterLastName,
                    mobileNumber: mobileNumber,
                    payeeMessage: 'Hotel Restaurant Payment',
                    cartSubtotal: cartSubtotal,
                    cartCheckoutTotal: cartCheckoutTotal,
                    paymentType: checkInNonMemberPaymentType,
                    payment_amount: enterMM_nonMember_amountRef.current.value,
                    cartLatitude: cartLatitude,
                    cartLongitude: cartLongitude,
                    }}></PayModal_Hotel_Restaurant>}


    </React.Fragment>)
}